import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ControlValueAccessor} from '@angular/forms';
import {debounceTime, Subject} from "rxjs";
import {SubSink} from "subsink";
import _ from "lodash";

const noop = () => {
};

@Component({
  template: ''
})
export class ControlValueAccessorBaseImpl<T> implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {

  onTouchedCallback: () => void = noop;
  onChangeCallback: (_: any) => void = noop;

  subSink: SubSink = new SubSink();
  $value!: T | undefined;
  private changeSubject: Subject<T | undefined> = new Subject<T | undefined>();
  disabled!: boolean;
  $required: boolean = false;

  private onChangeRegistered = false;
  private onTouchedRegistered = false;
  private subscribed  = false;


  @Input()
  debounce: number | undefined;

  @Input()
  readonly: boolean = false;

  @Input()
  set required(req: boolean) {
    this.$required = req;
  }

  get isRequired(): boolean {
    return this.$required;
  }

  get value() {
    return this.$value;
  }

  set value(val) {
    if (_.isEqual(val, this.$value)) return;
    this.$value = val;
    this.changeSubject.next(val);
  }

  writeValue(obj: any): void {
    if (_.isEqual(obj, this.$value)) return;
    this.$value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
    this.onChangeRegistered = true;
    this.trySubscription();
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
    this.onTouchedRegistered = true;
    this.trySubscription();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  private trySubscription() {
    if (this.onChangeRegistered && this.onTouchedRegistered && !this.subscribed) {
      this.subscribed = true;
      this.subSink.add(
        this.changeSubject
          .pipe(debounceTime(this.debounce ?? 0))
          .subscribe(value => {
            this.onChangeCallback(value);
            this.onTouchedCallback();
          }),
      );
    }
  }

}
